module.exports = __webpack_public_path__ + "static/bohater_5-f333440c744d28cbed93e3b09ca28133.png";